const METAFIELD_QUERY = `
  query getProductVariantsMetafields($productId: ID!, $namespace: String!, $key: String!) {
    product(id: $productId) {
      variants(first: 10) {
        edges {
          node {
            id
            title
            metafield(namespace: $namespace, key: $key) {
              value
              type
            }
          }
        }
      }
    }
  } 
`;

const getCachedData = (productId, namespace, key) => {
  const cache = localStorage.getItem(`${productId}-${namespace}-${key}`);
  if (!cache) return null;

  const data = JSON.parse(cache);
  if (new Date().getTime() - data.date < 86_400_000) {
    return data.value;
  }

  return null;
};

const storeCachedData = (productId, namespace, key, finalData) => {
  localStorage.setItem(
    `${productId}-${namespace}-${key}`,
    JSON.stringify({
      value: finalData,
      date: new Date().getTime(),
    })
  );
};

const getProductFirstVariantMetafield = async (productId, namespace, key) => {
  const endpoint = 'https://yourkaya.myshopify.com/api/2025-01/graphql.json';
  const storefrontAccessToken = '10565dd8dd1387fe67f673e8b7444d07';
  const variables = {
    productId: `gid://shopify/Product/${productId}`,
    namespace,
    key,
  };

  const cache = getCachedData(productId, namespace, key);
  if (cache) return cache;

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
      body: JSON.stringify({ query: METAFIELD_QUERY, variables }),
    });

    const result = await response.json();

    if (result.errors) {
      console.error('Błąd GraphQL:', result.errors);
      throw new Error('Błąd podczas pobierania metafieldu.');
    }

    if (result.data.product.variants.edges[0].node.metafield) {
      const finalData = JSON.parse(result.data.product.variants.edges[0].node.metafield.value);
      storeCachedData(productId, namespace, key, finalData);

      return finalData;
    }

    return null;
  } catch (error) {
    console.error('Błąd podczas wykonywania zapytania:', error);
    throw error;
  }
};

const renderPrice = async (element, id) => {
  if (!element || element.querySelector(`.omnibus[data-original="${id}"]`)) return;

  const { amount } = await getProductFirstVariantMetafield(id, 'app--320503809--omnibus', 'priceWithCoupons');
  if (!amount) return;

  element.querySelectorAll('.omnibus').forEach((element) => element.remove());
  element
    .querySelector('.rebuy-money.sale')
    .parentElement.insertAdjacentHTML(
      'beforeend',
      `<p class="omnibus" data-original="${id}" style="font-size: 10px;">Najniższa cena w zakupie jednorazowym z ostatnich 30 dni przed obniżką: ${formatPriceForGifts(amount)}</p>`
    );
};

const allowedWidgetsIds = [163405, 165133, 210561, 210564];
const allowedProductsPrefix = 'tag-omnibus_ho_original_product_';

const getHotOfferProducts = () => {
  const allowedWidgets = allowedWidgetsIds.map((id) => `#rebuy-widget-${id} .rebuy-product-block`);
  const items = document.querySelectorAll(allowedWidgets.join(', '));

  items.forEach((item) => {
    const hasOriginalProductClass = [...item.classList].find((cls) => cls.startsWith(allowedProductsPrefix));
    if (hasOriginalProductClass) renderPrice(item, hasOriginalProductClass.split('_')[4]);
  });
};

document.addEventListener('rebuy:smartcart.show', () => {
  setTimeout(getHotOfferProducts, 500);
});

document.addEventListener('rebuy:cart.change', () => {
  setTimeout(getHotOfferProducts, 500);
});

document.addEventListener('rebuy:cart.ready', () => {
  setTimeout(getHotOfferProducts, 500);
});
